/*
 * @创建文件时间: 2020-04-30 10:15:26
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-30 11:09:32
 * @联系Qq:1638245306
 * @文件介绍:  字符串工具
 */
class StringTools {
    /**
     * 判断字符串是空或者无长度字符串
     * @param str
     * @returns {boolean}
     */
    isNullOrEmpty (str) {
        if (typeof str === 'undefined' || str === null ){
            return true
        }
        str = str.trim()
        if (str.length === 0){
            return true
        }
        return false
    }
}

export default StringTools